import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  spin () {
    const svg = this.element.querySelector('svg')
    if (svg) svg.classList.add('animate-spin')
  }
}
